import { unwrapApiResponse } from "../utils/apiUtils";
import { api } from "./apiSlice";

// Trailer Assignment DTO
export interface TrailerAssignmentDto {
  id: number;
  trailerId: number;
  employeeId: number;
  startDate: string;
  endDate?: string;
  trailerUnitNumber?: string;
  trailerVIN?: string;
}

// Update Trailer Assignments DTO
export interface UpdateTrailerAssignmentsDto {
  employeeId: number;
  trailerIds: number[];
}

export const trailerAssignmentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllTrailerAssignments: builder.query<TrailerAssignmentDto[], void>({
      query: () => "trailerassignments",
      transformResponse: unwrapApiResponse,
      providesTags: ["TrailerAssignments"],
    }),

    getTrailerAssignmentsByDriverId: builder.query<TrailerAssignmentDto[], number>({
      query: (driverId) => `trailerassignments/${driverId}`,
      transformResponse: unwrapApiResponse,
      providesTags: (result, error, driverId) => [
        { type: "TrailerAssignments", id: driverId },
        "TrailerAssignments",
      ],
    }),

    updateTrailerAssignments: builder.mutation<boolean, { driverId: number; trailerIds: number[] }>({
      query: ({ driverId, trailerIds }) => ({
        url: `trailerassignments/${driverId}`,
        method: "PUT",
        body: { trailerIds },
      }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: (result, error, { driverId }) => [
        { type: "TrailerAssignments", id: driverId },
        "TrailerAssignments",
        "TruckDrivers",
      ],
    }),
  }),
});

export const {
  useGetAllTrailerAssignmentsQuery,
  useGetTrailerAssignmentsByDriverIdQuery,
  useUpdateTrailerAssignmentsMutation,
} = trailerAssignmentsApi;
